import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const Escalator = ({ width = 40, height = 40, fill = 'currentColor', ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M23.0098 16.0879H26.0117C26.7465 16.0879 27.3369 16.6843 27.3369 17.4141C27.3368 18.1504 26.7481 18.7393 26.0117 18.7393H23.9043L23.7246 18.9473L17.4854 26.1699L17.4824 26.1738C17.3619 26.3159 17.1844 26.3994 16.9893 26.3994H13.9883C13.2535 26.3994 12.6621 25.803 12.6621 25.0732C12.6624 24.3387 13.2587 23.748 13.9883 23.748H16.0869L16.2666 23.541L22.5137 16.3184L22.5176 16.3135C22.638 16.1716 22.8148 16.088 23.0098 16.0879Z"
                fill={fill}
                stroke={fill}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M17.385 15.4888C18.0723 15.4888 18.6295 14.9317 18.6295 14.2444C18.6295 13.5571 18.0723 13 17.385 13C16.6978 13 16.1406 13.5571 16.1406 14.2444C16.1406 14.9317 16.6978 15.4888 17.385 15.4888Z"
                fill={fill}
            />
            <path
                d="M18.024 15.9844H17.5952C16.8889 15.9844 16.3171 16.5561 16.3171 17.2624V20.7435L19.5543 16.9177C19.26 16.3627 18.6883 15.9844 18.024 15.9844Z"
                fill={fill}
            />
        </svg>
    );
};
